<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <textarea
    class="form-control comment-form-textarea mb-2"
    formControlName="title"
    placeholder="Écris ta réponse ici..."
    rows="3"
  ></textarea>

  <div class="d-flex justify-content-end gap-2">
    <button
      *ngIf="hasCancelButton"
      type="button"
      class="btn btn-outline-secondary"
      (click)="handleCancel.emit()"
    >
      Annuler
    </button>

    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="form.invalid"
    >
      {{ submitLabel }}
    </button>
  </div>
</form>